module.exports = __webpack_public_path__ + "img/YogaWarrior365.1acf4f8d.jpeg";